import { Component, Input, OnInit } from '@angular/core';
import { EditSiteComponent } from '../../dialogue/edit-site/edit-site.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/core/services/user.service';
import { RestAPIsService } from 'src/app/core/services/rest-apis.service';

@Component({
  selector: 'app-site-details',
  templateUrl: './site-details.component.html',
  styleUrls: ['./site-details.component.scss']
})
export class SiteDetailsComponent implements OnInit {
  @Input() siteData: any;

  constructor(private modalService: NgbModal, public userService: UserService, private restAPI: RestAPIsService) { }

  ngOnInit(): void {
  }

  // Open edit site modal
  openEditSiteModal(): void {
    const modalRef = this.modalService.open(EditSiteComponent);
    modalRef.componentInstance.selectedSite = this.siteData;
    this.restAPI.addCheckpoint({ event: 'EDIT_SITE' });
  }

}
